export enum SaeType {
  GTFS_RT = 'GTFS_RT',
  MY_BUS = 'My_Bus',
}
